import { render, staticRenderFns } from "./SetteMapsViewerModal.vue?vue&type=template&id=33041166&scoped=true&"
import script from "./SetteMapsViewerModal.vue?vue&type=script&lang=ts&"
export * from "./SetteMapsViewerModal.vue?vue&type=script&lang=ts&"
import style0 from "./SetteMapsViewerModal.vue?vue&type=style&index=0&id=33041166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33041166",
  null
  
)

export default component.exports